import React, { useRef } from 'react';
import {
  AlertDialog,
  AlertDialogLabel,
  AlertDialogDescription
} from '@reach/alert-dialog';
import Button from '@strava/ui/Button';
import createNetworkingClient from 'utils/networking-client';
import I18n from 'utils/I18n';
import styles from './index.scss';

import { useFeedEntityContext } from '../../../state/FeedEntityContext';
import {
  DELETE_COMMENT_CANCEL,
  DELETE_COMMENT_COMPLETE
} from '../../../state/feed-entity-actions';

const prefix = 'templates.comment_delete_dialog';

const CommentDeleteAlertDialog = () => {
  const { entityState, dispatch } = useFeedEntityContext();
  const cancelRef = useRef();
  const close = () => dispatch({ type: DELETE_COMMENT_CANCEL });

  const deleteComment = () => {
    const { comment, entityId } = entityState;
    const commentId = comment.comment_id;
    createNetworkingClient()
      .delete('/feed/comment', {
        data: { id: commentId }
      })
      .then(
        dispatch({
          type: DELETE_COMMENT_COMPLETE,
          payload: { entityId, commentId }
        })
      )
      .catch(() => {
        // TODO log error in monorepo
      });
  };

  return (
    <>
      {entityState.openCommentDeleteDialog && (
        <AlertDialog leastDestructiveRef={cancelRef}>
          <AlertDialogLabel />
          <AlertDialogDescription>
            {I18n.t(`${prefix}.are_you_sure`)}
          </AlertDialogDescription>
          <div className={styles.actionBtns}>
            <Button
              ref={cancelRef}
              data-testid="cancel-delete-comment-btn"
              onClick={close}
              type="button"
            >
              {I18n.t(`${prefix}.cancel`)}
            </Button>
            <div className={styles.okBtn}>
              <Button
                type="button"
                data-testid="confirm-delete-comment-btn"
                onClick={deleteComment}
              >
                {I18n.t(`${prefix}.ok`)}
              </Button>
            </div>
          </div>
        </AlertDialog>
      )}
    </>
  );
};

export default CommentDeleteAlertDialog;
